// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.step-indicator_stepIndicatorWrapper__k3sJ8 {
  display: flex;
  justify-content: left;
  width: 60%;
}

.step-indicator_stepIndicator__W4B65 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: min(37%, 129px);
}

.step-indicator_stepIndicator__W4B65 svg {
  width: 100%;
}

.step-indicator_stepIndicator__W4B65 svg circle {
  fill: var(--labelOverlayColor);
}

.step-indicator_stepIndicatorLabel__bU\\+Pb {
  -webkit-user-select: none;
          user-select: none;
  position: absolute;
  margin-top: 30px;
  font-weight: 400;
}

.step-indicator_forwardIndicator__5\\+oEu {
  justify-content: right;
}
`, "",{"version":3,"sources":["webpack://./src/components/overlay/step-indicator.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[".stepIndicatorWrapper {\n  display: flex;\n  justify-content: left;\n  width: 60%;\n}\n\n.stepIndicator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: min(37%, 129px);\n}\n\n.stepIndicator svg {\n  width: 100%;\n}\n\n.stepIndicator svg circle {\n  fill: var(--labelOverlayColor);\n}\n\n.stepIndicatorLabel {\n  user-select: none;\n  position: absolute;\n  margin-top: 30px;\n  font-weight: 400;\n}\n\n.forwardIndicator {\n  justify-content: right;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepIndicatorWrapper": `step-indicator_stepIndicatorWrapper__k3sJ8`,
	"stepIndicator": `step-indicator_stepIndicator__W4B65`,
	"stepIndicatorLabel": `step-indicator_stepIndicatorLabel__bU+Pb`,
	"forwardIndicator": `step-indicator_forwardIndicator__5+oEu`
};
export default ___CSS_LOADER_EXPORT___;
